module.exports = __webpack_public_path__ + "static/img/Gokegg.71bc87f.png";


//////////////////
// WEBPACK FOOTER
// ./static/image/Gokegg.png
// module id = 7KND
// module chunks = 1